import { useEffect, useState } from "react";
import { LangContext } from "../lib/LangContext";
import { WhatsAppModal } from "./WhatsAppModal";

// SubscribeModalHost is mounted at the app root (outside any per-page
// LangContext.Provider), so the modal wouldn't inherit the visitor's
// selected UI language. We provide our own LangContext sourced from
// `localStorage.ir_lang` and re-read it on every open so the modal
// always renders in the visitor's current language.
const LANG_KEY = "ir_lang";

const readLang = () => {
  try {
    const v = localStorage.getItem(LANG_KEY);
    if (v === "en" || v === "es" || v === "nl" || v === "pap") return v;
  } catch (_) { /* ignore */ }
  return "en";
};

export const SubscribeModalHost = () => {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(readLang);

  useEffect(() => {
    window.openSubscribeModal = (_src = "") => {
      // Refresh language snapshot on every open so a mid-session toggle
      // is respected without needing a re-mount.
      setLang(readLang());
      setOpen(true);
    };
    return () => { delete window.openSubscribeModal; };
  }, []);

  useEffect(() => {
    // React to language changes made in another tab.
    const onStorage = (e) => {
      if (e.key === LANG_KEY) setLang(readLang());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <LangContext.Provider value={lang}>
      <WhatsAppModal open={open} onClose={() => setOpen(false)} />
    </LangContext.Provider>
  );
};

export const openSubscribe = (source = "") => {
  if (typeof window !== "undefined" && typeof window.openSubscribeModal === "function") {
    window.openSubscribeModal(source);
  }
};
